import React from 'react';
import { AlertTriangle, Save, Trash2, X } from 'lucide-react';

const UnsavedChangesModal = ({ isOpen, onSave, onDiscard, onCancel, isLoading }) => {
  if (!isOpen) return null;

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      backdropFilter: 'blur(2px)'
    },
    modal: {
      backgroundColor: 'white',
      padding: '2.5rem',
      borderRadius: '12px',
      maxWidth: '520px',
      width: '90%',
      textAlign: 'center',
      fontFamily: 'Montserrat, sans-serif',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      transform: 'scale(1)',
      transition: 'all 0.2s ease-out'
    },
    icon: {
      fontSize: '3rem',
      marginBottom: '1rem',
      color: '#f59e0b'
    },
    title: {
      fontSize: '1.5rem',
      fontWeight: '600',
      marginBottom: '1rem',
      color: '#262626'
    },
    message: {
      marginBottom: '2.5rem',
      color: '#6b7280',
      lineHeight: '1.6',
      fontSize: '0.95rem'
    },
    buttonContainer: {
      display: 'flex',
      gap: '0.75rem',
      justifyContent: 'center',
      flexWrap: 'wrap'
    },
    button: {
      padding: '12px 24px',
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      fontWeight: '500',
      fontSize: '14px',
      minWidth: '110px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      transition: 'all 0.2s ease',
      fontFamily: 'Montserrat, sans-serif'
    },
    saveButton: {
      backgroundColor: '#51C7F2',
      color: 'white',
      '&:hover': {
        backgroundColor: '#3b9cd9'
      }
    },
    discardButton: {
      backgroundColor: '#ef4444',
      color: 'white',
      '&:hover': {
        backgroundColor: '#dc2626'
      }
    },
    cancelButton: {
      backgroundColor: '#6b7280',
      color: 'white',
      '&:hover': {
        backgroundColor: '#4b5563'
      }
    },
    loader: {
      width: '16px',
      height: '16px',
      border: '2px solid rgba(255, 255, 255, 0.3)',
      borderTop: '2px solid #ffffff',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.icon}>         
         <AlertTriangle size={48} strokeWidth={2.5} color="#f59e0b" />
        </div>
        <h3 style={styles.title}>Modifications non sauvegardées</h3>
        <p style={styles.message}>
          Vous avez apporté des modifications à votre profil qui n'ont pas été sauvegardées. 
          Que souhaitez-vous faire ?
        </p>
        <div style={styles.buttonContainer}>
          <button
            onClick={onSave}
            disabled={isLoading}
            style={{
              ...styles.button,
              ...styles.saveButton,
              opacity: isLoading ? 0.7 : 1,
              cursor: isLoading ? 'not-allowed' : 'pointer'
            }}
            onMouseEnter={(e) => {
              if (!isLoading) {
                e.target.style.backgroundColor = '#3b9cd9';
              }
            }}
            onMouseLeave={(e) => {
              if (!isLoading) {
                e.target.style.backgroundColor = '#51C7F2';
              }
            }}
          >
            {isLoading ? (
              <>
                <div style={styles.loader}></div>
                Sauvegarde...
              </>
            ) : (
              <>
                 <Save size={16} /> Sauvegarder
              </>
            )}
          </button>
          <button
            onClick={onDiscard}
            disabled={isLoading}
            style={{
              ...styles.button,
              ...styles.discardButton,
              opacity: isLoading ? 0.7 : 1,
              cursor: isLoading ? 'not-allowed' : 'pointer'
            }}
            onMouseEnter={(e) => {
              if (!isLoading) {
                e.target.style.backgroundColor = '#dc2626';
              }
            }}
            onMouseLeave={(e) => {
              if (!isLoading) {
                e.target.style.backgroundColor = '#ef4444';
              }
            }}
          >
             <Trash2 size={16} />  Ignorer
          </button>
          <button
            onClick={onCancel}
            disabled={isLoading}
            style={{
              ...styles.button,
              ...styles.cancelButton,
              opacity: isLoading ? 0.7 : 1,
              cursor: isLoading ? 'not-allowed' : 'pointer'
            }}
            onMouseEnter={(e) => {
              if (!isLoading) {
                e.target.style.backgroundColor = '#4b5563';
              }
            }}
            onMouseLeave={(e) => {
              if (!isLoading) {
                e.target.style.backgroundColor = '#6b7280';
              }
            }}
          >
               <X size={16} /> Annuler
          </button>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default UnsavedChangesModal;